import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BlogPost } from '../interface/blog.interface';
import { fetchBlogPosts, fetchBlogPostBySlug } from '../thunks/blog.thunk';

interface BlogState {
  posts: BlogPost[];
  currentPost: BlogPost | null;
  isLoading: boolean;
  isSinglePostLoading: boolean;
  error: string | null;
}

const initialState: BlogState = {
  posts: [],
  currentPost: null,
  isLoading: false,
  isSinglePostLoading: false,
  error: null,
};

const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    clearCurrentPost: (state) => {
      state.currentPost = null;
    },
    clearBlogError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Posts
      .addCase(fetchBlogPosts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBlogPosts.fulfilled, (state, action: PayloadAction<BlogPost[]>) => {
        state.isLoading = false;
        state.posts = action.payload;
      })
      .addCase(fetchBlogPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      
      // Fetch Single Post
      .addCase(fetchBlogPostBySlug.pending, (state) => {
        state.isSinglePostLoading = true;
        state.error = null;
      })
      .addCase(fetchBlogPostBySlug.fulfilled, (state, action: PayloadAction<BlogPost | null>) => {
        state.isSinglePostLoading = false;
        state.currentPost = action.payload;
      })
      .addCase(fetchBlogPostBySlug.rejected, (state, action) => {
        state.isSinglePostLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearCurrentPost, clearBlogError } = blogSlice.actions;
export default blogSlice.reducer;
